// Types
import { RootState } from 'types/RootState.types';

// Config
import routeConstants from '@constants/routeConstants';
import { isSinglePageCheckoutEnabledFeatureActive } from '@redux/reducers/config/configSelector';
import { getSelectedDeliveryChoiceIdSelector } from '@redux/reducers/delivery/deliverySelector';
import { isClickAndCollectChoice } from '@utils/delivery/deliveryHelper';

export const getSecureCheckoutEntryRoute = (state: RootState | undefined) => {
  if (!state) {
    // In the absence of state, default to delivery route to avoid potential redirect loop between secure and delivery routes
    return routeConstants.DELIVERY;
  }

  const singlePageCheckoutEnabled = isSinglePageCheckoutEnabledFeatureActive(state);

  if (singlePageCheckoutEnabled) {
    // If single page checkout is enabled, we want to route to secure directly as it will handle both delivery and click and collect flows
    return routeConstants.SECURE;
  }

  const selectedDeliveryChoiceId = getSelectedDeliveryChoiceIdSelector(state);
  const isClickAndCollectSelected = isClickAndCollectChoice(selectedDeliveryChoiceId);

  if (isClickAndCollectSelected) {
    // If click and collect is selected, route to click and collect entry point
    return routeConstants.CLICK_AND_COLLECT;
  }

  // For all other cases, route to delivery as the entry point for secure checkout
  return routeConstants.DELIVERY;
};

export default getSecureCheckoutEntryRoute;
